<ion-item-group
  data-form-section
  [formGroup]="form()"
>
  <ion-item-divider sticky>
    <ion-icon
      slot="start"
      aria-hidden="true"
      src="../assets/material-symbols/route_24dp.svg"
    ></ion-icon>
    <div class="segment-header-title">
      <p class="subtitle">Tramo {{ index() + 1 }}</p>
    </div>
    @if (totalSegments() > 1) {
      <ion-button
        slot="end"
        fill="clear"
        color="danger"
        size="small"
        (click)="removeSegment.emit()"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/delete_24dp.svg"
        ></ion-icon>
      </ion-button>
    }
  </ion-item-divider>

  <div class="detail-group">
    <ion-grid>
      <ion-row>
        <ion-col
          size-lg="8"
          size="12"
        >
          <ion-input
            formControlName="goodsDescription"
            type="text"
            label="Descripción de la mercancía"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            errorText="Obligatorio"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="4"
          size="12"
        >
          <ion-input
            formControlName="netWeight"
            type="number"
            label="Peso Neto (kg)"
            labelPlacement="floating"
            fill="outline"
            mode="md"
          ></ion-input>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <ion-row class="ion-no-padding">
    <ion-col
      size="12"
      size-lg="6"
      class="ion-no-padding"
    >
      <ion-item-group>
        <ion-item-divider sticky>
          <ion-icon
            slot="start"
            aria-hidden="true"
            src="../assets/material-symbols/line_start_circle_24dp.svg"
          ></ion-icon>
          <div>
            <p class="subtitle">Origen tramo {{ index() + 1 }}</p>
          </div>
        </ion-item-divider>

        <div class="detail-group">
          <lib-deca-edit-stop
            [form]="form().controls.origin"
            [locationData]="initialOriginLocation()"
            [previousAddressData]="index() > 0 ? previousAddressData() : null"
            (locationChange)="locationChange.emit({ type: 'origin', location: $event })"
          ></lib-deca-edit-stop>
        </div>
      </ion-item-group>
    </ion-col>
    <ion-col
      size="12"
      size-lg="6"
      class="ion-no-padding"
    >
      <ion-item-group>
        <ion-item-divider sticky>
          <ion-icon
            slot="start"
            aria-hidden="true"
            src="../assets/material-symbols/line_end_square_24dp.svg"
          ></ion-icon>
          <div>
            <p class="subtitle">Destino tramo {{ index() + 1 }}</p>
          </div>
        </ion-item-divider>

        <div class="detail-group">
          <lib-deca-edit-stop
            [form]="form().controls.destination"
            [locationData]="initialDestinationLocation()"
            (locationChange)="locationChange.emit({ type: 'destination', location: $event })"
          ></lib-deca-edit-stop>
        </div>
      </ion-item-group>
    </ion-col>
  </ion-row>
</ion-item-group>
